//筹款详情页面广告
// import detailsPageUsersImg  from '@/assets/info/insurance-content1.gif' //backUp
// import detailsPageUsersImg  from '@/assets/info/insurance-content1_c.png'
import detailsPageUsersImg  from '@/assets/info/insurance-content1_d.png'
// import detailsPageUsersImg_1b  from '@/assets/info/insurance-all.png'
import detailsPageUsersImg_1b  from '@/assets/info/insurance-content4.png'
import detailsPageImg from '@/assets/info/insurance-content2.gif'
// import detailsPageImg_1b from '@/assets/info/insurance-all.png'
import detailsPageImg_1b from '@/assets/info/insurance-all2.png'
import detailsPageFundsOnImg from '@/assets/info/insurance-all.png'
import detailsBelowImg from '@/assets/info/insurance-content4.gif'
// import detailsBelowImg_1b from '@/assets/info/insurance-all.png'
import detailsBelowImg_1b from '@/assets/info/insurance-under-b.gif'
// import donation_middle_List_img  from '@/assets/info/insurance_700.png'
import donation_middle_List_img  from '@/assets/info/insurance_700_c.gif'
import donation_middle_List_img_1b  from '@/assets/info/insurance_700_b.gif'
import fundraisingEnd_img1 from '@/assets/info/output-over.gif'
import fundraisingEnd_img1b from '@/assets/info/output-over_b.png'
// import fundraisingEnd_img1b from '@/assets/info/fundraisingEnd_img1b-1.png'
import donation_img_url from '@/assets/info/insurance_700.png'
import info_go_back_A_url from '@/assets/info/info_gobackA.gif'
import info_go_back_B_url from '@/assets/info/info_gobackB.gif'

//详情页上（用户证实上面
export const DETAILS_USERS_IMG_URL = detailsPageUsersImg
export const DETAILS_USERS_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072506'

//详情页上（b）
export const DETAILS_USERS_IMG_URL_1B = detailsPageUsersImg_1b
export const DETAILS_USERS_URL_1B = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025071701'
//详情页中（资料证明上面
export const MIDDLE_DETAILS_IMG_URL = detailsPageImg
export const MIDDLE_DETAILS_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026042314'
//详情页中（b）
export const MIDDLE_DETAILS_IMG_URL_1B = detailsPageImg_1b
export const MIDDLE_DETAILS_URL_1B = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025080804'
//详情页资金流向上面
export const DETAILS_PAGE_FUNDS_ON_IMG_URL = detailsPageFundsOnImg
export const DETAILS_PAGE_FUNDS_ON_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081408'

//详情页下（平台声明上面
export const DETAILS_BELOW_IMG_URL= detailsBelowImg
export const DETAILS_BELOW_URL='https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081405'

//详情页下（ b ）
export const DETAILS_BELOW_IMG_URL_1B= detailsBelowImg_1b
// export const DETAILS_BELOW_URL_1B='https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025080504'
export const DETAILS_BELOW_URL_1B='https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026042316'



//捐赠列表中
export const DONATION_MIDDLE_LIST_IMG_URL = donation_middle_List_img
// export const DONATION_MIDDLE_LIST_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072507'
export const DONATION_MIDDLE_LIST_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026042315'

//捐赠列表中（b） 已停用
export const DONATION_MIDDLE_LIST_IMG_URL_1B = donation_middle_List_img_1b
export const DONATION_MIDDLE_LIST_URL_1B = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081406' //已停用

//筹款结束
export const FUNDRAISING_ENDS_IMG_URL = fundraisingEnd_img1
export const FUNDRAISING_ENDS_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072504'

//筹款结束（b）
export const FUNDRAISING_ENDS_IMG_URL_1B = fundraisingEnd_img1b
export const FUNDRAISING_ENDS_URL_1B = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025081403'

//捐赠列表下
export const DONATION_LIST_IMG_URL = donation_img_url
export const DONATION_LIST_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072508'

//返回拦截弹窗（1）
export const INFO_GO_BACK_A_IMG_URL = info_go_back_A_url
export const INFO_GO_BACK_A_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025082017'

//返回拦截弹窗（1b）//停用
export const INFO_GO_BACK_B_IMG_URL = info_go_back_B_url
export const INFO_GO_BACK_B_URL = 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025082017'
